import { AUTH_TYPES } from '../actions/authActions';

// Helper functions to handle localStorage
const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('authState', JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save state to localStorage:', error);
  }
};

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('authState');
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (error) {
    console.error('Failed to load state from localStorage:', error);
    return undefined;
  }
};

// Initialize state with persisted data or defaults
const initialState = loadFromLocalStorage() || {
  isLoggedIn: false,
  userData: null,
  registrationData: {
    plant_info: [],
    machining_info: [],
  },
  token: localStorage.getItem('accessToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null,
  isVerified: false,
};

const authReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case AUTH_TYPES.SET_USER_DATA:
      newState = {
        ...state,
        userData: {
          ...action.payload,
          role: action.payload.role || null, // Role is optional
        },
        isLoggedIn: true,
      };
      break;

    case AUTH_TYPES.SET_USER_PROFILE:
      newState = {
        ...state,
        userProfile: {
          ...action.payload,
        },
      };
      break;

    case AUTH_TYPES.LOGIN_USER:
      const { x_auth_key, isVerified, ...userDataWithoutAuth } = action.payload;
      newState = {
        ...state,
        userData: userDataWithoutAuth,
        token: x_auth_key || state.token,
        isVerified: isVerified || false,
        isLoggedIn: true,
      };
      break;

    case AUTH_TYPES.SET_AUTH_TOKEN:
      localStorage.setItem('accessToken', action.payload);
      newState = { ...state, token: action.payload };
      break;

    case AUTH_TYPES.SET_REFRESH_TOKEN:
      localStorage.setItem('refreshToken', action.payload);
      newState = { ...state, refreshToken: action.payload };
      break;

    case AUTH_TYPES.SET_VERIFICATION_STATUS:
      newState = { ...state, isVerified: action.payload };
      break;

    case AUTH_TYPES.REGISTER_USER_SUPPLIER:
      newState = {
        ...state,
        registrationData: {
          ...state.registrationData,
          ...action.payload,
        },
      };
      break;

    case AUTH_TYPES.SET_PLANT_INFO:
      newState = {
        ...state,
        registrationData: {
          ...state.registrationData,
          plant_info: action.payload,
        },
      };
      break;

    case AUTH_TYPES.SET_MACHINE_INFO:
      newState = {
        ...state,
        registrationData: {
          ...state.registrationData,
          machining_info: action.payload, // Update the machining_info array inside registrationData
        },
      };
      break;

    case AUTH_TYPES.LOGOUT_USER:
      // Clear token and persisted auth state
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('authState');
      localStorage.removeItem('authKeyExpiredAt');
      localStorage.removeItem('loglevel');
      localStorage.removeItem('authState');
      localStorage.removeItem('projectState');
      localStorage.removeItem('searchState');
      localStorage.removeItem('dumpState');
      // Reset to the initial state without saving
      return { ...initialState };

    case AUTH_TYPES.SET_USER_COMMENTS:
      newState = {
        ...state,
        userData: {
          ...state.userData,
          comments: action.payload,
        },
      };
      break;

    default:
      newState = state;
  }

  // every action except logout will save the state to localStorage
  if (action.type !== AUTH_TYPES.LOGOUT_USER) {
    saveToLocalStorage(newState);
  }

  return newState;
};

export default authReducer;
